export default __webpack_public_path__ + "static/media/menuIcon.0483b574.svg";